import SliderInput from './Slider';
import { useLanguage } from '../../context/LanguageContext';

export default function SliderTrust({ value, onChange }) {
  const { t } = useLanguage();

  return (
    <SliderInput
      description={[
        `${t('noTrust')}`,
        `${t('littleTrust')}`,
        `${t('somewhatTrust')}`,
        `${t('mostlyTrust')}`,
        `${t('completelyTrust')}`,
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
